"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));
var _toggleBookmark = _interopRequireDefault(require("@micado-digital/react-bookmark/ReactBookmark/toggleBookmark"));
var _fireCustomEvent = _interopRequireDefault(require("@micado-digital/react-ui/utils/fireCustomEvent"));
var _ShopContext = _interopRequireDefault(require("../../../context/ShopContext"));
var _ProductDetailContext = _interopRequireDefault(require("../../../ProductDetail/context/ProductDetailContext"));
var _Bookmark = _interopRequireDefault(require("./Bookmark.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Bookmark = () => {
  const {
    shopData
  } = (0, _react.useContext)(_ShopContext.default);
  const {
    productDetailData
  } = (0, _react.useContext)(_ProductDetailContext.default);
  const {
    combinationID = 0,
    objectType = "shop-product"
  } = productDetailData || {};
  const css = (0, _Bookmark.default)();
  const handleAddToBookmark = () => {
    var _shopData$currency, _productDetailData$pr, _productDetailData$pr2;
    (0, _fireCustomEvent.default)("add_to_wishlist", {
      ecommerce: {
        currency: shopData === null || shopData === void 0 || (_shopData$currency = shopData.currency) === null || _shopData$currency === void 0 ? void 0 : _shopData$currency.isoCode,
        value: productDetailData === null || productDetailData === void 0 || (_productDetailData$pr = productDetailData.price) === null || _productDetailData$pr === void 0 ? void 0 : _productDetailData$pr.amount,
        items: [{
          item_name: productDetailData === null || productDetailData === void 0 ? void 0 : productDetailData.title,
          item_variant: productDetailData === null || productDetailData === void 0 ? void 0 : productDetailData.combinationID,
          price: productDetailData === null || productDetailData === void 0 || (_productDetailData$pr2 = productDetailData.price) === null || _productDetailData$pr2 === void 0 ? void 0 : _productDetailData$pr2.amount
        }]
      }
    });
  };
  const handleRemoveFromBookmark = () => {
    var _shopData$currency2, _productDetailData$pr3, _productDetailData$pr4;
    (0, _fireCustomEvent.default)("remove_from_wishlist", {
      ecommerce: {
        currency: shopData === null || shopData === void 0 || (_shopData$currency2 = shopData.currency) === null || _shopData$currency2 === void 0 ? void 0 : _shopData$currency2.isoCode,
        value: productDetailData === null || productDetailData === void 0 || (_productDetailData$pr3 = productDetailData.price) === null || _productDetailData$pr3 === void 0 ? void 0 : _productDetailData$pr3.amount,
        items: [{
          item_name: productDetailData === null || productDetailData === void 0 ? void 0 : productDetailData.title,
          item_variant: productDetailData === null || productDetailData === void 0 ? void 0 : productDetailData.combinationID,
          price: productDetailData === null || productDetailData === void 0 || (_productDetailData$pr4 = productDetailData.price) === null || _productDetailData$pr4 === void 0 ? void 0 : _productDetailData$pr4.amount
        }]
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement(_toggleBookmark.default, {
    className: (0, _clsx.default)(css.bookmark, "mco-shop-product-detail-bookmark"),
    componentBookmarked: /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      color: "primary",
      src: "/img/icons/shop/bookmark-selected.svg",
      size: 24
    }),
    componentBookmarkedHover: /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      color: "primary",
      src: "/img/icons/shop/bookmark-selected.svg",
      size: 24
    }),
    componentDefault: /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      color: "primary",
      src: "/img/icons/shop/bookmark.svg",
      size: 24
    }),
    componentHover: /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      color: "primary",
      src: "/img/icons/shop/bookmark-selected.svg",
      size: 24
    }),
    data: {
      ...productDetailData,
      combinationID,
      objectType
    },
    validationFields: ["id", "combinationID", "objectType"],
    onAdded: handleAddToBookmark,
    onRemoved: handleRemoveFromBookmark
  });
};
var _default = exports.default = Bookmark;